export default __webpack_public_path__ + "static/media/clip_history.d5e72894.png";